import { render, staticRenderFns } from "./RegisterStep1.vue?vue&type=template&id=3498cf2c&scoped=true&"
import script from "./RegisterStep1.vue?vue&type=script&lang=js&"
export * from "./RegisterStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3498cf2c",
  null
  
)

export default component.exports